import { Button, Popconfirm } from "antd";

import { userRoles } from "@evolved/constants";
import { useResetOrganization } from "../data/use-organization";
import { useMe } from "../data/use-me";
import { useInternal } from "../hooks/use-internal";

export const ResetOrganization = (props) => {
  const user = useMe();
  const resetOrganization = useResetOrganization();

  const isOn = useInternal();

  if (!isOn) {
    return null;
  }

  if (user.role > userRoles.ROLES.MANAGER) {
    return null;
  }

  return (
    <Popconfirm
      title="Reset Organization"
      description="Are you sure to reset your organization?"
      onConfirm={resetOrganization.mutate}
      okText="Yes"
      cancelText="No"
    >
      <Button
        danger
        ghost
        loading={resetOrganization.isLoading}
        disable={resetOrganization.isLoading}
        style={props.style}
      >
        Reset Organization
      </Button>
    </Popconfirm>
  );
};


